export const VERIFICATION_UPDATED_AT = "VERIFICATION_UPDATED_AT";

export interface VerificationUpdatedAtAction {
  type: typeof VERIFICATION_UPDATED_AT;
}
